var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14.395C4.247 10.703.667 7.531.667 4.795c0-2.528 2.045-3.462 3.52-3.462.875 0 2.768.334 3.813 2.972 1.06-2.646 2.976-2.965 3.817-2.965 1.694 0 3.516 1.08 3.516 3.454 0 2.713-3.424 5.75-7.333 9.601z",
    fill: "#000"
  })));
}

export default SvgHeart;